<div class="w-p-100 h-p-100 p-30 flex flex-col">
  <div class="pos-relative full-grow-no-shrink-no-basis">
    <div class="keno-grid-container">
      <particle-smart-grid [sourceType]="sourceType" [selectableSettings]="false"
                           (valueChanged)="onValueChanged($event)">
      </particle-smart-grid>
    </div>
  </div>
</div>
